var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.818,
    height: 92.868,
    viewBox: "0 0 71.818 92.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32400",
    x: 0,
    y: 0,
    width: 71.818,
    height: 92.868,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32400)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32400-2",
    "data-name": "Path 32400",
    d: "M23.747-1.574a22.369,22.369,0,0,1-9.333,7.518A33.659,33.659,0,0,1,.312,8.692a53.974,53.974,0,0,1-9.747-.933,61.8,61.8,0,0,1-9.592-2.541,38.334,38.334,0,0,1-7.622-3.577l5.185-9.125a38.366,38.366,0,0,0,9.436,3.94A39.84,39.84,0,0,0-1.14-1.988Q6.222-1.988,10.422-5a9.744,9.744,0,0,0,4.2-8.4,8.813,8.813,0,0,0-4.148-7.881q-4.148-2.7-12.029-2.7H-8.087a9.257,9.257,0,0,1-1.089-2.592,11.52,11.52,0,0,1-.467-3.111q0-5.392,6.533-5.392h2.074q6.844,0,10.732-2.852a8.985,8.985,0,0,0,3.889-7.622,8.716,8.716,0,0,0-3.992-7.673,17.688,17.688,0,0,0-10.11-2.7,23.18,23.18,0,0,0-11.147,2.592q-4.822,2.592-6.377,6.222A8.314,8.314,0,0,1-22.6-49.274a5.752,5.752,0,0,1-1.867-4.355,7.625,7.625,0,0,1,.518-2.644,8.4,8.4,0,0,1,1.763-2.748q3.007-3.318,9.073-5.237A42.928,42.928,0,0,1-.1-66.176,35.243,35.243,0,0,1,13.74-63.687,21.1,21.1,0,0,1,22.762-56.9a16.444,16.444,0,0,1,3.163,10.007,16.929,16.929,0,0,1-3.111,10.007,21.47,21.47,0,0,1-8.607,7,19.1,19.1,0,0,1,9.54,6.377,16.971,16.971,0,0,1,3.422,10.732A19,19,0,0,1,23.747-1.574Z",
    transform: "translate(35.65 72.18)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon3);
export default __webpack_public_path__ + "static/media/number-icon3.7be85736797c7de44958dfcd181af6da.svg";
export { ForwardRef as ReactComponent };